<template>
  <product-section-card :title="$t('branch_detail.about.title')" class="product-section-about">
    <product-section-address />
    <product-section-desc />
    <product-section-facilities />
    <template v-for="info in aboutInfos" :key="info.name">
      <product-about-card v-if="info.content?.length" :title="info.title" class="mb-4 <md:last:mb-0" :class="info.name">
        {{ info.content.map(item => item.name).join(', ') }}
      </product-about-card>
    </template>
  </product-section-card>
</template>

<script lang="ts" setup>
import ProductSectionCard from '@/components/product/product-detail/product-section-card.vue'
import ProductSectionAddress from '@/components/product/product-detail/product-section-address.vue'
import ProductSectionDesc from '@/components/product/product-detail/product-section-desc.vue'
import ProductSectionFacilities from '@/components/product/product-detail/product-section-facilities.vue'
import ProductAboutCard from '@/components/product/product-detail/product-about-card.vue'

const { t } = useI18n()

const { branch } = useBranchDetailContext()

const aboutInfos = computed(() => [
  {
    name: 'product-cuisines',
    title: t('branch_detail.about.cuisines'),
    content: branch.value?.cuisine_tags,
  },
  {
    name: 'product-atmospheres',
    title: t('branch_detail.about.atmospheres'),
    content: branch.value?.atmospheres,
  },
  {
    name: 'product-spoken-langs',
    title: t('branch_detail.about.spoken_langs'),
    content: branch.value?.service_languages,
  },
  {
    name: 'product-payment-opts',
    title: t('branch_detail.about.payment_opts'),
    content: branch.value?.payment_methods,
  },
  {
    name: 'product-special-diets',
    title: t('branch_detail.about.special_diets'),
    content: branch.value?.special_diets,
  },
])
</script>
